<div class="pointCF__field">
  <label class="pointCF__label">
    <div class="pointCF__label-image--container">
      @if (ppVolyActive === EIntegrationStatus.OFF) {
        <pp-icon
          [ppSrc]="EIconPath.ICON_FIELDS_LIST_18"
          ppColor="inherit"
          ppClass="setSize18"
          ppTooltip
          [ppTitle]="ppFieldDescription"
        />
      }
      @if (ppVolyActive === EIntegrationStatus.ON) {
        <img
          [src]="EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_BIG"
          ppTooltip
          [ppTitle]="'custom_field_voly_tooltip' | ppTranslate"
        />
      }
      @if (ppVolyActive === EIntegrationStatus.DISABLED) {
        <img
          [src]="EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_BIG"
          ppTooltip
          [ppTitle]="'custom_field_voly_disabled_tooltip' | ppTranslate"
        />
      }
    </div>

    <span
      ppTooltip
      class="pointCF__label-container"
      ppTitle="{{ ppFieldLabel }}"
      [ppTrimTooltip]="true"
    >
      {{ ppFieldLabel }}
    </span>

    @if (ppFieldDescription) {
      <pp-point-fields-custom-field-description
        [ppDescription]="ppFieldDescription"
      ></pp-point-fields-custom-field-description>
    }
  </label>

  <div class="pointCF__content" #list>
    <div
      #pointFieldsList
      [id]="buttonId"
      class="pointCF__input pointCF__input--list"
      [ngClass]="{ 'pointCF__input--focus': focused }"
      [class.pointCF__input--error]="error"
      [class.pointCF__input--disabled]="!ppCanEdit || ppIsLocked"
      (click)="showList()"
      ppTooltip
      [ppTitle]="ppIsLocked ? ('locked_by_admin' | ppTranslate) : null"
    >
      @if (ppFieldValue) {
        <span>{{ ppFieldValue }}</span>
      } @else {
        <span class="placeholder-text">{{ 'select...' | ppTranslate }}</span>
      }

      @if (ppIsLocked) {
        <pp-icon
          data-test="cf-list-locked-icon"
          [ppSrc]="EIconPath.PADLOCK_CLOSED"
          ppColor="grey-400"
          ppClass="setSize18"
        />
      }
    </div>

    <pp-save-indicator
      [ppFocused]="focused"
      [ppFilled]="!!ppFieldValue"
      [ppUpdating]="updating"
      [ppShowClearBtn]="ppCanEdit && !ppIsLocked"
      (ppAction)="clearCustomField()"
    >
    </pp-save-indicator>

    <ng-container>
      @if (!ppIsLocked) {
        <div
          class="pointCF__dropdown-icon"
          [class.pointCF__input--list--hide-arrow]="focused && ppFieldValue"
          [class.pointCF__dropdown-icon--hide-hover]="!!ppFieldValue"
          (click)="arrowClicked()"
        >
          <div class="select__icon-container">
            <pp-icon
              [ppSVG]="
                dropdown.visible && dropdown.buttonId === buttonId
                  ? iconMap[EIconPath.ICON_MISC_UP_ARROW_18]
                  : iconMap[EIconPath.ICON_MISC_DOWN_ARROW_18]
              "
              ppColor="grey-400"
              ppClass="setSize18"
            ></pp-icon>
          </div>
        </div>
      }
    </ng-container>
  </div>
</div>
